module.exports = __webpack_public_path__ + "static/media/cancel_icon.1fa06185.svg";